// generated file — do not edit
export const APP_VERSION = 'v2.54.0';
